export default function Reducer(prevState, action) {
    switch (action.type) {
        case "IS_LOADING":
            return {
                ...prevState,
                is_loading: true,
            };
        case "IS_LOADED":
            return {
                ...prevState,
                is_loading: false,
                total_ftms: action.total_ftms,
                total_pages: action.total_pages,
                ftms: action.ftms,
                ftm_stages: action.ftm_stages
            };
        case "UPDATE_CURRENT_PAGE":
            return {
                ...prevState,
                page_number: action.page_number
            }
        case "SET_SERACH_TEXT":
            return {
                ...prevState,
                page_number: 1,
                serach_text: action.serach_text,
            };
        case "SET_SORT_CONFIG":
            return {
                ...prevState,
                sort_key: action.sort_key,
                sort_direction: action.sort_direction,
            };
        default:
            return prevState;
    }
}